import { Link } from "react-router-dom";

interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.href ? `${typeof window !== "undefined" ? window.location.origin : ""}${item.href}` : undefined,
    })),
  };

  return (
    <nav aria-label="面包屑导航" className="py-3">
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <ol className="flex items-center flex-wrap gap-2 text-sm">
        <li>
          <Link
            to="/"
            className="text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1"
          >
            <i className="ri-home-4-line text-xs" />
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-300 text-xs" />
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-500 transition-colors"
              >
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium" aria-current="page">
                {item.name}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}